import React, { useEffect, useState, useCallback } from "react";
import Select from "react-select";
import { debounce } from "lodash";
import axios from "axios";

const ProjectCategorySelector = ({
  setSelectedOption,
  setSpecializationData,
  resetSpecialization,
  selectedData,
}) => {
  const [options, setOptions] = useState([]);
  const [categoryMenuOpen, setCategoryMenuOpen] = useState(false);
  const [categoriesLoading, setCategoriesLoading] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      setCategoriesLoading(true);
      try {
        const response = await axios.get(`/api/data/project-category`);
        const categoryOptions = response?.data?.map((cat) => ({
          value: cat,
          label: cat,
        }));
        setOptions(categoryOptions || []);
      } catch (error) {
        console.error("Error fetching job categories:", error);
        setOptions([]);
      } finally {
        setCategoriesLoading(false);
        setIsInitialLoad(false);
      }
    };
    fetchCategories();
  }, []);

  const debouncedSpecializationFetch = useCallback(
    debounce(async (value) => {
      if (!value) return;

      try {
        const response = await axios.get(`/api/data/specialization`, {
          params: { profileCategory: value },
        });
        const specializationOptions = response?.data?.map((sp) => ({
          value: sp,
          label: sp,
        }));
        setSpecializationData(specializationOptions || []);
      } catch (error) {
        console.error("Error fetching specializations:", error);
        setSpecializationData([]);
      }
    }, 200),
    [setSpecializationData],
  );

  const handleChange = (option) => {
    setSelectedOption(option);
    if (option?.value) {
      debouncedSpecializationFetch(option.value);
      resetSpecialization();
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      cursor: "text",
    }),
    input: (provided) => ({
      ...provided,
      cursor: "text",
    }),
    loadingIndicator: (provided) => ({
      ...provided,
      display: "none",
    }),
    menu: (provided) => ({
      ...provided,
      position: "absolute",
      top: "100%",
      left: 0,
      width: "100%",
      zIndex: 10,
    }),
    // menuPortal: (base) => ({
    //   ...base,
    //   zIndex: 9999,
    // }),
  };

  return (
    <div className="job-select-container">
      <Select
        options={options}
        onChange={handleChange}
        value={selectedData}
        classNamePrefix="react-select"
        placeholder="Select Category.."
        onFocus={() => setCategoryMenuOpen(true)}
        onBlur={() => setCategoryMenuOpen(false)}
        menuIsOpen={categoryMenuOpen}
        isLoading={categoriesLoading}
        loadingMessage={() => "Loading categories..."}
        noOptionsMessage={() => {
          if (isInitialLoad || categoriesLoading) {
            return "Loading categories...";
          }
          return "No categories found";
        }}
        onMenuClose={() => setCategoryMenuOpen(false)}
        onMenuOpen={() => setCategoryMenuOpen(true)}
        styles={customStyles}
        menuPosition="absolute"
        menuPlacement="bottom"
        menuShouldScrollIntoView={false}
        closeMenuOnScroll={false}
      />
    </div>
  );
};

export default React.memo(ProjectCategorySelector);
